import request from "./request";

//刷新token
export function refreshToken(params) {
  return request({
    url: "/hkweb/refreshToken",
    params,
    method: "post",
    isToken: true,
  });
}

// 获取密码公钥
export function getPublicKey() {
  return request({
    url: "/hkweb/publicKey",
    method: "get",
  });
}

// 获取手机号验证码
export function getCode(phone) {
  return request({
    url: "/hkweb/dx/s/" + phone,
    method: "get",
    isToken: true,
  });
}

// 获取手机号验证码
export function getLoginCode(phone, vCode) {
  return request({
    url: `/hkweb/dx/login/code/${phone}/${vCode}`,
    method: "get",
  });
}

// 获取手机号验证码
export function getRegisterCode(phone, vCode) {
  return request({
    url: `/hkweb/dx/register/code/${phone}/${vCode}`,
    method: "get",
  });
}

// 通过token获取验证码
export function smsSend(type) {
  return request({
    url: "/hkweb/dx/send?type=" + type,
    method: "get",
    isToken: true,
  });
}

// 注册
export function register(data) {
  return request({
    url: "/hkweb/client/zc",
    method: "post",
    data,
  });
}

// 登录
export function login(data) {
  return request({
    url: "/hkweb/dl",
    method: "post",
    data,
  });
}

// 账户金额
export function getAmountInfo() {
  return request({
    url: "/hkweb/client/user/info",
    method: "get",
    isToken: true,
  });
}

// 账户首页
export function getUserIndex() {
  return request({
    url: "/hkweb/client/user/index",
    method: "get",
    isToken: true,
  });
}

// 个人资料
export function getMemberInfo() {
  return request({
    url: "/hkweb/client/me",
    method: "get",
    isToken: true,
  });
}

// 忘记密码账号校验
export function forgetPwdVerify(params) {
  return request({
    url: "/hkweb/forgetPwdVerify",
    params,
    method: "get",
  });
}

// 获取修改密码短信
export function verifyCode(verifyCode) {
  return request({
    url: `/hkweb/dx/verCode/${verifyCode}`,
    method: "get",
  });
}

// 短信验证码校验
export function postVerifyCode(data) {
  return request({
    url: `/hkweb/dx/verifyCode`,
    data,
    method: "post",
    isToken: true,
  });
}

//验证验证码
export function forgetPwdVerifySmsCode(params) {
  return request({
    url: "/hkweb/forgetPwdVerifySmsCode",
    params: { ...params },
    method: "post",
  });
}

//忘记密码修改密码
export function forgetPwdChange(data) {
  return request({
    url: "/hkweb/forgetPwdChange",
    data,
    method: "post",
  });
}

// 账户首页
export function userInfo() {
  return request({
    url: "/hkweb/client/user/index",
    method: "get",
    isToken: true,
  });
}

// 上传头像
export function uploadPicture(data) {
  return request({
    url: "/hkweb/upload/image",
    data,
    method: "post",
    isToken: true,
  });
}

// 个人资料修改
export function userEdit(data) {
  return request({
    url: "/hkweb/client/update",
    data,
    method: "post",
    isToken: true,
  });
}

// 安全中心
export function securityCenter() {
  return request({
    url: "/hkweb/client/safe",
    method: "get",
    isToken: true,
  });
}

// 身份认证保存
export function userIdentitySave(data) {
  return request({
    url: "/hkweb/rz/sfz/create",
    data,
    method: "post",
    isToken: true,
  });
}

// 修改密码
export function userPwdUpdate(data) {
  return request({
    url: "/hkweb/client/pwd/change",
    data,
    method: "post",
    isToken: true,
  });
}

// 设置邮箱
export function userEmailAdd(data) {
  return request({
    url: "/hkweb/client/email/save",
    data,
    method: "post",
    isToken: true,
  });
}

// 修改邮箱
export function userEmailUpdate(data) {
  return request({
    url: "/hkweb/client/email/update",
    data,
    method: "post",
    isToken: true,
  });
}

// 邮箱认证
export function userVerifyEmail(params) {
  return request({
    url: "/hkweb/rz/email/submit",
    params,
    method: "get",
    isToken: true,
  });
}

// 修改手机号
export function userMobileUpdate(data) {
  return request({
    url: "/hkweb/client/ph/change",
    data,
    method: "post",
    isToken: true,
  });
}

// 我的认证
export function myCertification() {
  return request({
    url: "/hkweb/rz/myVerify",
    method: "get",
    isToken: true,
  });
}

// 个人认证认证列表
export function userIdentityList(params) {
  return request({
    url: "/hkweb/rz/sfz/retrieve",
    params,
    method: "get",
    isToken: true,
  });
}

// 企业认证保存
export function enterpriseIdentitySave(data) {
  return request({
    url: "/hkweb/rz/qy/create",
    data,
    method: "post",
    isToken: true,
  });
}

// 个人认证删除
export function userIdentityDelete(data) {
  return request({
    url: `/hkweb/rz/sfz/delete/${data}`,
    method: "DELETE",
    isToken: true,
  });
}

// 企业认证
export function enterpriseIdentityList(params) {
  return request({
    url: "/hkweb/rz/qy/retrieve",
    params,
    method: "get",
    isToken: true,
  });
}

// 企业认证认证图片
export function enterpriseIdentityUpload(data) {
  return request({
    url: `/hkweb/rz/verifyQyImage`,
    data,
    method: "post",
    isToken: true,
  });
}

// 企业认证删除
export function enterpriseIdentityDelete(data) {
  return request({
    url: `/hkweb/rz/delete/qy/${data}`,
    method: "DELETE",
    isToken: true,
  });
}

// 邮箱认证
export function certifiedEmailList(params) {
  return request({
    url: "/hkweb/rz/email/retrieve",
    params,
    method: "get",
    isToken: true,
  });
}

// 邮箱删除
export function certifiedEmailDelete(data) {
  return request({
    url: `/hkweb/rz/email/delete/${data}`,
    method: "DELETE",
    isToken: true,
  });
}

// 重新发送邮箱认证
export function certifiedEmailSendEmail(data) {
  return request({
    url: `/hkweb/rz/email/send`,
    params: { ...data },
    method: "post",
    isToken: true,
  });
}

// 登录日志
export function loginLogList(params) {
  return request({
    url: "/hkweb/rz",
    params,
    method: "get",
    isToken: true,
  });
}

// 充值接口
export function payRecharge(data) {
  return request({
    url: `/hkweb/pay/recharge`,
    data,
    method: "post",
    isToken: true,
  });
}

// 获取银行卡列表
export function bankCardList(params) {
  return request({
    url: "/hkweb/yhk/retrieve",
    params,
    method: "get",
    isToken: true,
  });
}

// 添加银行卡
export function createBankCard(data) {
  return request({
    url: `/hkweb/yhk/create`,
    data,
    method: "post",
    isToken: true,
  });
}

// 获取银行卡名称
export function getBankName(params) {
  return request({
    url: "/hkweb/yhk/retrieve/" + params,
    params,
    method: "get",
    isToken: true,
  });
}

// 银行卡删除
export function bankCardDelete(data) {
  return request({
    url: `/hkweb/yhk/delete//${data}`,
    method: "DELETE",
    isToken: true,
  });
}

// 获取提现比例
export function userLevel(params) {
  return request({
    url: "/hkweb/client/rate",
    params,
    method: "get",
    isToken: true,
  });
}

// 提现申请
export function withdraw(data) {
  return request({
    url: `/hkweb/withdrawal/save`,
    data,
    method: "post",
    isToken: true,
  });
}

// 提现记录
export function withdrawalPageList(params) {
  return request({
    url: "/hkweb/withdrawal/list",
    params,
    method: "get",
    isToken: true,
  });
}

// 取消申请提现
export function cancelCashOut(withdrawalId) {
  return request({
    url: "/hkweb/withdrawal/" + withdrawalId,
    method: "PATCH",
    isToken: true,
  });
}

// 财务类型
export function financeTypeList(params) {
  return request({
    url: "/hkweb/client/financial",
    params,
    method: "get",
    isToken: true,
  });
}

// 资金明细
export function financeList(params) {
  return request({
    url: "/hkweb/client/capital",
    params,
    method: "get",
    isToken: true,
  });
}

// 获取发票列表
export function invoiceList(params) {
  return request({
    url: "/hkweb/invoice/pageList",
    params,
    method: "get",
    isToken: true,
  });
}

// 取消发票申请
export function invoiceCancel(data) {
  return request({
    url: `/hkweb/invoice/cancel`,
    data,
    method: "post",
    isToken: true,
  });
}

// 发票信息查询
export function invoiceInfoList(params) {
  return request({
    url: "/hkweb/invoice/getList",
    params,
    method: "get",
    isToken: true,
  });
}

// 发票信息保存
export function invoiceInfoSave(data) {
  return request({
    url: `/hkweb/invoice/save`,
    data,
    method: "post",
    isToken: true,
  });
}

// 发票信息单个查询
export function invoiceInfoDetail(params) {
  return request({
    url: "/hkweb/invoice/getOne",
    params,
    method: "get",
    isToken: true,
  });
}

// 发票类型
export function invoiceTypeList(params) {
  return request({
    url: "/hkweb/invoice/type",
    params,
    method: "get",
    isToken: true,
  });
}

// 获取发票数据
export function invoiceInvoiceAmountList(params) {
  return request({
    url: "/hkweb/invoice/list",
    params,
    method: "get",
    isToken: true,
  });
}

// 获取发票总金额
export function invoiceTotalInvoiceAmount(params) {
  return request({
    url: "/hkweb/invoice/amount",
    params,
    method: "get",
    isToken: true,
  });
}

// 默认发票
export function invoiceDefault(params) {
  return request({
    url: "/hkweb/invoice/default",
    params,
    method: "get",
    isToken: true,
  });
}

// 发票信息查询全部
export function invoiceInfoMore(params) {
  return request({
    url: "/hkweb/invoice/getAll",
    params,
    method: "get",
    isToken: true,
  });
}

// 发票信息申请
export function applyMakeInvoice(data) {
  return request({
    url: `/hkweb/invoice/apply`,
    data,
    method: "post",
    isToken: true,
  });
}

// 发票信息根据ID查询
export function invoiceInvoiceDetail(params) {
  return request({
    url: "/hkweb/invoice/detail",
    params,
    method: "get",
    isToken: true,
  });
}

// 域名解析-列表
export function resolutionList(params) {
  return request({
    url: "/hkweb/dn/resolution/retrieve",
    params,
    method: "get",
    isToken: true,
  });
}

// 域名解析-启用记录
export function resolutionRecordStart(data) {
  return request({
    url: `/hkweb/dn/resolution/record/start/${data}`,
    method: "post",
    isToken: true,
  });
}

// 域名解析-暂停记录
export function resolutionRecordPause(data) {
  return request({
    url: `/hkweb/dn/resolution/record/pause/${data}`,
    method: "post",
    isToken: true,
  });
}

// 域名解析-删除记录
export function resolutionRecordRemove(data) {
  return request({
    url: `/hkweb/dn/resolution/record/delete`,
    data,
    method: "DELETE",
    isToken: true,
  });
}

// 域名解析-获取记录类型、线路
export function resolutionGetRoute(params) {
  return request({
    url: "/hkweb/dn/resolution/line",
    params,
    method: "get",
    isToken: true,
  });
}

// 域名解析-保存记录
export function resolutionSave(data) {
  return request({
    url: `/hkweb/dn/resolution/record/create`,
    data,
    method: "post",
    isToken: true,
  });
}

// 域名解析-保存记录
export function resolutionModify(data) {
  return request({
    url: `/hkweb/dn/resolution/record/update`,
    data,
    method: "post",
    isToken: true,
  });
}

// 获取DNS-根据ID获取
export function domainDnsList(params) {
  return request({
    url: "/hkweb/dn/getDns",
    params,
    method: "get",
    isToken: true,
  });
}

// 设置DNS-保存记录
export function domainDnsCreate(data) {
  return request({
    url: `/hkweb/dn/updateDns`,
    data,
    method: "post",
    isToken: true,
  });
}

// 获取DNS-dns日志
export function domainDnsLogList(params) {
  return request({
    url: "/hkweb/dn/getDnsLog",
    params,
    method: "get",
    isToken: true,
  });
}

// 获取域名信息
export function domainDetail(params) {
  return request({
    url: "/hkweb/dn/getDnInfo",
    params,
    method: "get",
    isToken: true,
  });
}

// 获取域名证书
export function getDownloadDomainPicById(params) {
  return request({
    url: "/hkweb/dn/download",
    params,
    method: "get",
    responseType: "arraybuffer",
    isToken: true,
  });
}

// 站内信类型
export function mailSiteType() {
  return request(
    {
      url: "/hkweb/messageTemplates/siteType",
      method: "get",
      isToken: true,
    },
  );
}

// 获取站内信列表
export function mailSiteList(data) {
  return request(
    {
      url: "/hkweb/messageTemplates/siteList",
      method: "post",
      data,
      isToken: true,
    }
  );
}


// 站内信设置已读
export function mailSiteRead(data) {
  return request(
    {
      url: "/hkweb/messageTemplates/siteRead",
      method: "post",
      data,
      isToken: true,
    }
  );
}



// 删除站内信
export function mialSiteDel(data) {
  return request(
    {
      url: "/hkweb/messageTemplates/siteDel",
      method: "post",
      data,
      isToken: true,
    }
  );
}
